import { isArray, isObject, isString } from "ionic-angular/util/util";
import { Control } from "../../../vas/business-objects/control/control.model";
import { Field } from "../../../vas/business-objects/field/field.model";
import { IJobPointer, Job, JobPointerEnum } from "../../../vas/business-objects/job/job.model";

export interface IJobPointerModelArgs {
    pointer: IJobPointer | IJobPointer;
    type: JobPointerEnum;
    sourceJob: Job;
    field?: Field;
    control?: Control;
}

export class JobPointerModel {
    protected _pointer: IJobPointer | IJobPointer;
    protected _type: JobPointerEnum;
    protected _sourceJob: Job;
    protected _field?: Field;
    protected _control?: Control;

    constructor(args: IJobPointerModelArgs) {
        Object.keys(args).forEach(key => {
            this[ `_${key}` ] = args[ key ];
        });
    }

    get type(): JobPointerEnum {
        return this._type;
    }

    get sourceReference(): string {
        return this._sourceJob ? this._sourceJob.reference : "";
    }

    get targetReference(): string {
        return this._pointer ? this._pointer.reference : "";
    }

    get jobId(): string {
        return this._pointer ? this._pointer.job : "";
    }

    get controlName(): string {
        return this._control ? this._control.name : "";
    }

    get controlTitle(): string {
        return this._control ? this._control.title : "";
    }

    get fieldValue(): string {

        if (!this._field) {
            return "";
        }

        if (isArray(this._field.value)) {
            return this._field.value.join(", ");
        }

        if (isObject(this._field.value)) {
            try {
                return JSON.parse(this._field.value);
            } catch (e) {
                return "";
            }
        }

        if (!isString(this._field.value)) {
            console.warn("unable to convert field value to string", this._field.value);
            return "";
        }

        return this._field.value;
    }

    get description(): string {

        switch (this.type) {
            case JobPointerEnum.FIELD : {
                return `This job has the same value for <strong>${this.controlTitle}</strong> as <strong>${this.targetReference}</strong> `;
            }
            case JobPointerEnum.NEXT : {
                return `This job was copied to <strong>${this.targetReference}</strong>`;
            }
            case JobPointerEnum.PREVIOUS : {
                return `This job was copied from <strong>${this.targetReference}</strong>`;
            }
            default: {
                return "";
            }
        }
    }

    get icon(): string {

        switch (this.type) {
            case JobPointerEnum.FIELD: {
                return "copy";
            }
            case JobPointerEnum.NEXT: {
                return "redo";
            }
            case JobPointerEnum.PREVIOUS: {
                return "undo";
            }
            default: {
                return "";
            }
        }


    }
}



// WEBPACK FOOTER //
// ./src/app/atoms/job-card-pointers/job-pointer.model.ts